export const DESKTOP_OFFER_PDF_URL = "/offers/offer_desktop.pdf";
export const TG_OFFER_PDF_URL = "/offers/offer_tg.pdf";
